// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../index';

import { gql } from 'graphql-tag';
import { ProductPageFacetedContentLongDescriptionFragmentDoc } from './productPageFacetedContentLongDescription.fragment.generated';
import { MetaFragmentDoc } from '../../fragments/meta.fragment.generated';
export const ProductPageFacetedContentFragmentDoc = gql`
    fragment productPageFacetedContent on ProductPageFacetedContent {
  title
  contentTitle
  description
  longDescription {
    ...productPageFacetedContentLongDescription
  }
  productString
  meta {
    ...meta
  }
}
    ${ProductPageFacetedContentLongDescriptionFragmentDoc}
${MetaFragmentDoc}`;